import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import React from "react";
import transparent from '../../assets/images/transparent_overlay.png';

function SensorSuite() {
    const [image, setVehicleImage] = React.useState('bg-car')
    const tooltipCommonProps = React.useMemo(() => {
        const props = {
            place: "right",
            className: "sensorSuiteTooltip",
            positionStrategy: "fixed",
            offset: 10,
        };
        if (typeof document !== "undefined") {
            props.appendTo = () => document.body;
        }
        return props;
    }, []);
    return (
        <>
            <map name="workMap">
                <area alt=""
                      style ={{outline: 'none'}}
                      onMouseEnter={() => setVehicleImage('bg-radar')}
                      onMouseLeave={() => setVehicleImage('bg-car')}
                      data-tooltip-id="Radar"
                      data-tooltip-float={true}
                      shape="rectangle" coords="210, 10, 240, 70"/>
                <area alt=""
                      onMouseOver={() => setVehicleImage('bg-lidar')}
                      onMouseLeave={() => setVehicleImage('bg-car')}
                      data-tooltip-id="Lidar"
                      data-tooltip-float={true}
                      shape="rectangle" coords="210, 70, 240, 90"/>
                <area alt=""
                      onMouseOver={() => setVehicleImage('bg-gnss')}
                      onMouseLeave={() => setVehicleImage('bg-car')}
                      data-tooltip-id="GNSS"
                      data-tooltip-float={true}
                      shape="rectangle" coords="210, 90, 240, 130"/>
                <area alt=""
                      onMouseOver={() => setVehicleImage('bg-camera')}
                      onMouseLeave={() => setVehicleImage('bg-car')}
                      data-tooltip-id="Camera"
                      data-tooltip-float={true}
                      shape="rectangle" coords="240, 90, 280, 110"/>
            </map>
            <ReactTooltip id='Radar' {...tooltipCommonProps}>
                <p className={"tooltipHeader"}>Radar</p>
                <span>
                    Navtech RAS6 360° Spinning FMCW Radar <br/>

                    &#8226; 1 km range <br/>
                    &#8226; 0.9&#176; horizontal resolution <br/>
                    &#8226; 400 azimuths/rotation <br/>
                    &#8226; 4 Hz <br/>
                </span>
            </ReactTooltip>
            <ReactTooltip id='Lidar' {...tooltipCommonProps}>
                <p className={"tooltipHeader"}>LiDAR</p>
                <span>
                    Ouster OS1-128 3D LiDAR <br/>

                    &#8226; 45&#176; VFOV <br/>
                    &#8226; Range up to 100m <br/>
                    &#8226; 100k+ points per scan <br/>
                    &#8226; 10 Hz<br/>
                    &#8226; Integrated IMU (100 Hz)<br/>
                </span>
            </ReactTooltip>
            <ReactTooltip id='GNSS' {...tooltipCommonProps}>
                <p className={"tooltipHeader"}>Post-Processed GNSS</p>
                <span>
                    Novatel OEM7 GNSS <br/>

                    &#8226; Post-processed RTK <br/>
                    &#8226; ~2–4 cm RMS accuracy <br/>
                    &#8226; Interpolated to 1000 Hz <br/>
                </span>
            </ReactTooltip>
            <ReactTooltip id='Camera' {...tooltipCommonProps}>
                <p className={"tooltipHeader"}>Stereo Camera</p>
                <span>
                    Teledyne Bumblebee Stereo Camera <br/>

                    &#8226; 1152&#215;2048 per eye <br/>
                    &#8226; Rectified images <br/>
                    &#8226; 10 Hz <br/>
                </span>
            </ReactTooltip>
            <img src={transparent} className={image} useMap="#workMap" hidefocus={"true"} alt={''}/>
        </>
    )
}

export default SensorSuite;
